/* components/patterns/kitchen/KitchenFilterDrawer.jsx — секции фильтров реестра.
   Оборачивает общий S1 `FilterDrawer` (// переиспользует, не дублирует Drawer).
   Локальный «черновик» выбора → применяется по «Готово» (явный, предсказуемый —
   фикс боли №34); «Сбросить» очищает черновик. Бейдж активных — на кнопке тулбара.
   ХЕНДОФФ → frontend/components/kitchen/FilterDrawer.jsx (контент-сборка секций). */

import React from 'react';
import { FilterDrawer } from '../Overlays.jsx';
import { Checkbox } from '../../ui/Field.jsx';

  const { useState, useEffect } = React;

  function KitchenFilterDrawer({ open, onClose, sections = [], value = {}, onChange }) {
    const [draft, setDraft] = useState(value);
    useEffect(() => { if (open) setDraft(value || {}); /* eslint-disable-next-line */ }, [open]);

    const toggle = (key, v) => setDraft((d) => {
      const arr = d[key] || [];
      const has = arr.includes(v);
      return { ...d, [key]: has ? arr.filter((x) => x !== v) : [...arr, v] };
    });
    const count = Object.values(draft).reduce((n, a) => n + (a ? a.length : 0), 0);

    return (
      <FilterDrawer open={open} onClose={onClose} activeCount={count}
        onReset={() => setDraft({})}
        onApply={() => onChange && onChange(draft)}>
        {sections.map((s) => (
          <section className="kt-filter-sec" key={s.key}>
            <h4 className="kt-filter-sec__title t-eyebrow">{s.title}</h4>
            <div className="kt-filter-sec__opts">
              {s.options.map((o) => (
                <Checkbox key={o.value} label={o.label}
                  checked={(draft[s.key] || []).includes(o.value)}
                  onChange={() => toggle(s.key, o.value)} />
              ))}
            </div>
          </section>
        ))}
      </FilterDrawer>
    );
  }

export { KitchenFilterDrawer };
